import { ComponentPropsWithoutRef, FC, useEffect, useState } from 'react';

import DEFAULT_FALLBACK from '../../../../../apps/legacy/public/image-M.png';
import { StyledImage } from './Image.styles';

type ImageFit = 'contain' | 'cover' | 'fill' | 'none' | 'scale-down';

export interface Props extends ComponentPropsWithoutRef<'img'> {
	alt: string;
	describedBy?: string;
	fallback?: string;
	fit?: ImageFit;
}

export const Image: FC<Props> = ({ alt, fallback = DEFAULT_FALLBACK, describedBy, src, srcSet, ...rest }) => {
	const [currentSrc, setCurrentSrc] = useState(src?.length ? src : fallback);

	useEffect(() => {
		if (src) {
			const img = new window.Image();
			img.src = src;
			img.onload = () => setCurrentSrc(src);
			img.onerror = () => setCurrentSrc(fallback);
		}
	}, [src, fallback]);

	const effectiveSrcSet = currentSrc === fallback ? undefined : srcSet;

	return (
		<StyledImage
			alt={alt}
			src={currentSrc}
			srcSet={effectiveSrcSet}
			aria-describedby={describedBy ? describedBy : undefined}
			{...rest}
		/>
	);
};
